const Loader = () => {
    const style = {
        backgroundColor: "rgba(255, 255, 255, 0.5)",
        zIndex: 9,
        top: 0,
        left: 0,
    };

    return (
        <div
            className="align-items-center d-flex h-100 justify-content-center position-absolute w-100"
            style={style}
        >
            <span className="spinner-border" role="status" aria-hidden="true"></span>
        </div>
    );
};

export default Loader;
